export default {
  // Currently used
  home_search_for_product: "Wyszukaj produkt",
  conventional_alternative: "Konwencjonalna alternatywa",
  led_alternative: "Alternatywa LED",
  search_filters_filter: "Filtr",
  //alt_filters_filter: "",
  search_submit: "Wyszukaj produkt",
  results: "Wyniki",
  selected_product: "Wybrany produkt",
  search_input: "Wpisz (część) kodu produktu lub opisu",
  what_type_are_you_looking_for: "Jakiego rodzaju zamiennika produktu szukasz?",
  recommendations_singular: "Rekomendacje",
  recommendations_plural: "Rekomendacje",
  your_product: "Twój produkt",
  search_filters_reset: "Wyczyść filtry",
  results_specify: "Jest więcej niż 10 wyników, proszę dokładniej sprecyzuj swoje wyszukiwanie",
  energy_efficient: "Energooszczędny",
  active_filters: "Aktywne filtry",
  card_action: "Katalog",
  card_show_more: "Pokaż więcej",
  card_show_less: "Pokaż mniej",
  card_alternative_fit: "Najlepsza alternatywa firmy Philips",
  card_perfect_fit: "Najlepsze dopasowanie firmy Philips",
  no_results_found: "Nie znaleziono wyników. Wypróbuj inne zapytanie",
  results_no_recommendations: "Nie znaleziono wyników? Aby znaleźć rozwiązanie, skontaktuj się z lokalnym opiekunem klienta lub przedstawicielem handlowym.",
  led_no_recommendations: "Nie znaleziono alternatywy LED dla tego produktu.",
  ballast_notice: "Kompatybilność ze statecznikiem elektronicznym (HF) musi być sprawdzona",
  ballast_notice_tled_link_text: "Lista zgodności stateczników dla LEDtubes",
  ballast_notice_pl_led_link_text: "Lista zgodności stateczników dla LED PL",

  //LED facets
  search_filter_product_type: "Typ produktu",
  lighting_type: "Typ świetlówki",
  ean: "Kod EAN",
  product_code: "Kod produktu",
  eoc: "KOD EOC",
  family: "Rodzina produktów",
  discrete_wattage: "Moc [W]",
  wattage: "Moc [W]",
  brand: "Marka",
  driver_type: "Typ sterownika",
  number_of_lamps: "Liczba źródeł światła",
  length: "Długość",
  color: "Barwa światła",
  base: "Trzonek",
  local_eoc: "Lokalny Kod",
  lumen: "Strumień [lm]",
  energy_saving: "Oszczędzanie energii",
  //tiering: "",
  //ballast_compatibility: "",
  //lifetime: "",

  // Conventional facets
  ignitor: "Zapłonik",
  height: "Wysokość",
  width: "Szerokość",
  mounting_hole: "Otwór montażowy",
  mains_voltage: "Napięcie sieciowe (230 V)",
  thermal_protection: "Zabezpieczenie termiczne",
  delta_temperature: "Delta temperatury",
  energy_efficiency: "Klasa energetyczna",
  losses: "Straty",
  lamp_current: "Prąd lampy",
  pf_cap: "Współczynnik mocy",
};
